import React, { useEffect, useState } from "react";
import SearchBar from "./searchBar";
import ResultTable from "./resultTable";
import FilterModal from "./filterModal";
import Moment from "moment";
import { useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { GetProtocolos } from "../../logic/aplication/getProtocolos";
import { ProtocoloService } from "../../logic/domain/services/protocoloService";
import { ApiImplementation } from "../../logic/infraestructure/api/apiImplementation";
import { Protocolo } from "../../logic/domain/entities/protocolo";
import PrestacionModal from "./prestacionModal";
import { GetHistoricos } from "../../logic/aplication/getHistoricos";
import { PrestacionHistorico } from "../../logic/domain/entities/prestacionHistorico";
import DialogModal from "./dialog";

interface ListadoProtocolosProps {
  onLogoutListadoProtocolos: () => void;
}

const ListadoProtocolos: React.FC<ListadoProtocolosProps> = ({ onLogoutListadoProtocolos }) => {
  const theme = useTheme();
  const [filtro, setFiltro] = useState({
    startDate: "2018-10-01",
    endDate: Moment().format("YYYY-MM-DD"),
    cantidad: 5,
    visto: "all",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [isPrestacionModalOpen, setIsPrestacionModalOpen] = useState(false);
  const [localStorageUpdate, setLocalStorageUpdate] = useState(false);
  const [prestacionHistorico, setprestacionHistorico] = useState<PrestacionHistorico[]>([]);
  const [loading, setLoading] = useState(false); // Estado para el loading
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  const apiImplementation = new ApiImplementation();
  const protocoloService = new ProtocoloService(apiImplementation);
  const getProtocolos = new GetProtocolos(protocoloService);
  const getHistorico = new GetHistoricos(protocoloService);

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      return;
    }

    getProtocolos.execute(
      filtro.startDate,
      filtro.endDate,
      localStorage.getItem("token") as string
    ).then((response: Protocolo[]) => {
      const sortedData = response.sort(
        (a, b) => new Date(b.getFechaPedido()).getTime() - new Date(a.getFechaPedido()).getTime()
      );

      localStorage.setItem("protocolos", JSON.stringify(sortedData));
      setLocalStorageUpdate(!localStorageUpdate);
    }).catch((error: { message: any; }) => {
      console.error(error.message);
    });
  }, [filtro.startDate, filtro.endDate]);

  const handleFilterChange = (value: string | number, type: string) => {
    setFiltro((prev) => ({ ...prev, [type]: value }));
  };

  const handleSearchChange = (event: { target: { value: React.SetStateAction<string>; }; }) => {
    setSearchQuery(event.target.value);
  };

  const handleFilterModalOpen = () => {
    setIsFilterModalOpen(true);
  };

  const handleFilterModalClose = () => {
    setIsFilterModalOpen(false);
  };

  const handlePrestacionModalOpen = async (protocolo: Protocolo) => {
    setLoading(true); // Iniciar el loading
    try {
      const historicos = await getHistorico.execute(protocolo.getIdOrdenTrabajo(), localStorage.getItem('token') || '');
      setprestacionHistorico(historicos);
    } catch (error) {
      console.error("Error al obtener los históricos:", error);
      setErrorModalOpen(true)
      setErrorMessage("Sesión expirada")
    } finally {
      setLoading(false); // Terminar el loading
    }
    setIsPrestacionModalOpen(true);
  };

  const handlePrestacionModalClose = () => {
    setIsPrestacionModalOpen(false);
  };

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <div>
      <SearchBar
        searchQuery={searchQuery}
        onSearchChange={handleSearchChange}
        onFilterClick={handleFilterModalOpen}
        isSmallScreenSearchBar={isSmallScreen}
      />

      <ResultTable
        isSmallScreenResult={isSmallScreen}
        filtroResultTable={filtro}
        searchQuery={searchQuery}
        localStorageUpdateResultTable={localStorageUpdate}
        onLogoutResultTable={onLogoutListadoProtocolos}
        onPrestacionClick={handlePrestacionModalOpen}
      />
      
      <FilterModal
        open={isFilterModalOpen}
        onClose={handleFilterModalClose}
        onFilterChange={handleFilterChange}
        filtro={filtro}
      />

      <PrestacionModal 
        open={isPrestacionModalOpen} 
        onClose={handlePrestacionModalClose} 
        prestacionHistorico={prestacionHistorico}
        loading={loading}
      />

      <DialogModal onLogoutFromMenu={onLogoutListadoProtocolos} errorMessage={errorMessage} open={errorModalOpen} />
    </div>
  );
};

export default ListadoProtocolos;
